import React from "react";
import "./pagestyles.css";
import Layout from "../components/Layout";

const Contact = () => (
    <Layout>
        <></>
    </Layout>
)
  
export default Contact